import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader} from 'semantic-ui-react';
import {findIndex} from 'lodash';
import {dealerListForForcastSale} from '../../common/constants/lists';
import {dealerListNames} from '../utils/list';
import {colSumTotal, getTotal, rowQuantities} from '../utils/sumGeneral';


class DataTable extends Component {
  render() {
    return (
      <Card raised fluid>
        <Table fixed className='gray-table'>
          <Table.Header>
            <Table.Row textAlign='center'>
              <Table.HeaderCell className='lightgray-bg'>Modelos</Table.HeaderCell>
              {this.renderDealersName()}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.renderLoaderOrSales()}
          </Table.Body>
          {this.renderTotals()}
        </Table>
      </Card>
    );
  }

  renderDealersName() {
    const dealersList = dealerListNames(dealerListForForcastSale);
    const idxTotal = findIndex(dealersList, {'text': 'TOTAL OBJETIVO'});
    return dealersList.map((dealer, index) => (
      <Table.HeaderCell key={index}
        className={`lightgray-bg ${index === idxTotal && 'forcast-dealers-total-highlight'}`}>
        {dealer.text}
      </Table.HeaderCell>
    ));
  }
  
  renderLoaderOrSales() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderTableInformation();
  }

  renderTableInformation() {
    const {vehicles} = this.props;
    const {salesList} = this.props;
    const dealerList = dealerListNames(dealerListForForcastSale);
    const idxTotal = findIndex(dealerList, {'text': 'TOTAL OBJETIVO'});
    
    return vehicles.map((vehicle, index) => {
      const rows = rowQuantities(vehicle.id, salesList, dealerList);
      return (
        <Table.Row textAlign='center' key={index}>
          <Table.Cell collapsing className='lightgray-bg'>{vehicle.name}</Table.Cell>
          {this.renderDataByModelAndDealer(rows, idxTotal)}
        </Table.Row>
      );
    });
  }

  renderDataByModelAndDealer(rows, idxTotal) {
    return rows.map((initialValue, idx) => {
      let value = initialValue;
      const isTotalRow = idx === idxTotal;
      if (isTotalRow) {
        // only if it's total cal the total of the arr until idxTotal
        value = rows.slice(0, idxTotal).reduce((acc, rowValue) => acc + rowValue, 0);
      }
      return (
        <Table.Cell key={idx} className={`${isTotalRow && 'forcast-dealers-total-highlight'} `}>{value}</Table.Cell>
      );
    });
  }

  renderTotals() {
    const {loading} = this.props;
    if (loading) {
      return null;
    }

    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell className='lightgray-bg'>Total</Table.HeaderCell>
          {this.renderTotalByDealer()}
        </Table.Row>
      </Table.Footer>
    );
  }
  
  renderTotalByDealer() {
    const {salesList} = this.props;
    const dealersList = dealerListNames(dealerListForForcastSale);
    const dealersAndObjectivesTotals = colSumTotal(dealersList, salesList);
    const totals = getTotal(dealersAndObjectivesTotals);
    return totals.map((value, index) =>
      <Table.HeaderCell key={index} className='lightgray-bg'>{value}</Table.HeaderCell>);
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.saleForecast.loading,
    'salesList': state.saleForecast.listByDealersAndModels,
    'vehicles': state.vehiclesModels.vehicles,
  };
};

export default connect(mapStateToProps, {
})(DataTable);
